import React, { useEffect } from 'react';
import { useSortable } from '@dnd-kit/react/sortable';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';
import { selectGraphsStatus } from '@/redux/selectors/dashboardSelectors';
import { DragTypes } from './Widgets/WidgetFrame';

type WidgetContainerProps = {
  children: React.ReactNode;
  id: string;
  index: number;
  group: string;
  noDrag?: boolean;
  onDropTarget: (isDropTarget: boolean) => void;
};

export const WidgetContainer = ({ children, id, index, noDrag, group, onDropTarget }: WidgetContainerProps) => {
  const status = useAppSelector(selectGraphsStatus);
  const isSortDisabled = noDrag || !status.editable;
  const { ref, isDragSource, isDropTarget, isDragging, isDropping } = useSortable({
    id,
    index,
    data: {
      type: DragTypes.card,
      group
    },
    disabled: isSortDisabled,
    type: 'card',
    accept: 'card',
    group
  });

  useEffect(() => {
    onDropTarget(isDropTarget && !isDragging && !isDragSource && !isDropping);
  }, [isDropTarget]);

  return (
    <Wrapper className="pane" ref={ref} data-dragging={isDragSource} isSortDisabled={isSortDisabled}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isSortDisabled: boolean }>`
  width: 100%;
  border: none;
  cursor: ${({ isSortDisabled }) => (isSortDisabled ? 'default' : 'grab')};
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  transform: scale(1);

  [data-dragging='true'] {
    transform: scale(1.02);
  }
`;
